"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignatureDataERC2771 = void 0;
const utils_1 = require("../../../utils");
const network_1 = require("../../network");
const utils_2 = require("../utils");
const getSignatureDataERC2771 = (request, walletOrProvider, type) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!walletOrProvider.provider) {
            throw new Error(`Missing provider`);
        }
        const isSupported = yield (0, network_1.isNetworkSupported)(Number(request.chainId));
        if (!isSupported) {
            throw new Error(`Chain id [${request.chainId}] is not supported`);
        }
        const parametersToOverride = yield (0, utils_1.populateOptionalUserParameters)(request, walletOrProvider);
        const struct = yield (0, utils_2.mapRequestToStruct)(request, parametersToOverride);
        const signature = yield (0, utils_1.signTypedDataV4)(walletOrProvider, request.user, (0, utils_2.getPayloadToSign)(struct, type, (0, utils_1.isWallet)(walletOrProvider)));
        return {
            struct,
            signature,
        };
    }
    catch (error) {
        const errorMessage = error.message;
        throw new Error(`GelatoRelaySDK/getSignatureDataERC2771: Failed with error: ${errorMessage}`);
    }
});
exports.getSignatureDataERC2771 = getSignatureDataERC2771;
